module.exports = __webpack_public_path__ + "img/Madelyn_Cecily_Ryan.4f001b9f.jpeg";